module.exports = __webpack_public_path__ + "img/tetelu-1.eab3187f.jpg";